// LUMINA · pages/vajra/YuanqiObservationPage.jsx
// 缘起观察 — 会员专属智慧参考服务说明页

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GD, GDL, GDB, BG, TXT, TXT2 } from './constants';

const FONT = "'Noto Serif SC','Noto Serif',serif";

const SYSTEMS = [
  { icon:"🌙", zh:"八字命理", en:"Bazi", desc_zh:"出生时空的能量印记，天干地支五行生克", desc_en:"The energy imprint of your birth moment — stems, branches, and elemental dynamics" },
  { icon:"🌟", zh:"紫微斗数", en:"Ziwei", desc_zh:"星曜轨迹与生命格局，十四主星宫位布局", desc_en:"Star trajectories and life blueprint — fourteen main stars across twelve palaces" },
  { icon:"⚡", zh:"六爻占卜", en:"Liuyao", desc_zh:"当下缘起的动态呈现，用神世爻旺衰判断", desc_en:"Dynamic snapshot of current conditions — yongshen, worldly line, and phase" },
  { icon:"🌀", zh:"奇门遁甲", en:"Qimen", desc_zh:"时空方位的能量流转，吉门方位时机抉择", desc_en:"Energy flow through time and space — auspicious gates, directions, and timing" },
];

const SCENARIOS = [
  { icon:"💼", zh:"事业抉择", desc_zh:"创业、转职、投资、合伙的时机与方向", en:"Career decisions", desc_en:"Timing and direction for startups, job changes, investments, partnerships" },
  { icon:"💍", zh:"人生转折", desc_zh:"婚姻、搬迁、求学的缘起分析", en:"Life transitions", desc_en:"Yuanqi analysis for marriage, relocation, and further study" },
  { icon:"☸️", zh:"修行指引", desc_zh:"闭关时机、法门选择、修行道路的参考", en:"Dharma guidance", desc_en:"Retreat timing, practice path selection, lineage connection" },
  { icon:"🌿", zh:"困境参考", desc_zh:"健康、关系、财务困境的缘起视角", en:"Navigating challenges", desc_en:"Yuanqi perspective on health, relationship, and financial obstacles" },
];

export default function YuanqiObservationPage({ lang = "zh", member }) {
  const navigate = useNavigate();
  const L = (zh, en) => lang === "zh" ? zh : en;

  return (
    <div style={{ minHeight:"100vh", background:BG, fontFamily:FONT, color:TXT }}>

      {/* Nav */}
      <div style={{
        position:"sticky", top:0, zIndex:100,
        background:"rgba(253,251,247,0.94)", backdropFilter:"blur(16px)",
        borderBottom:"1px solid rgba(212,175,55,0.25)",
        padding:"0 32px", height:56,
        display:"flex", alignItems:"center", justifyContent:"space-between",
      }}>
        <button onClick={()=>navigate("/vajra")}
          style={{display:"flex",alignItems:"center",gap:10,background:"none",border:"none",cursor:"pointer",padding:0}}>
          <span style={{color:GD,fontSize:18}}>☸</span>
          <div>
            <div style={{color:GD,fontSize:14,letterSpacing:3,fontFamily:FONT}}>{L("如意宝金刚社群","BTF Canada Vajra Community")}</div>
            <div style={{color:TXT2,fontSize:9,letterSpacing:2,opacity:.8,fontFamily:FONT}}>BTF CANADA</div>
          </div>
        </button>
        <button onClick={()=>navigate(-1)} style={{
          background:"none",border:`1.5px solid rgba(107,79,16,0.35)`,
          borderRadius:8,color:GD,fontSize:12,
          padding:"6px 18px",cursor:"pointer",letterSpacing:1,fontFamily:FONT,
        }}>
          {L("返回 / Back","Back")}
        </button>
      </div>

      <div style={{maxWidth:820,margin:"0 auto",padding:"48px 24px 80px"}}>

        {/* Header */}
        <div style={{textAlign:"center",marginBottom:48,paddingBottom:32,borderBottom:"1px solid rgba(212,175,55,0.2)"}}>
          <div style={{fontSize:32,marginBottom:12}}>🔮</div>
          <h1 style={{margin:0,fontSize:30,fontWeight:700,color:GD,fontFamily:FONT,letterSpacing:3}}>
            {L("缘起观察","Yuanqi Observation")}
          </h1>
          <div style={{fontSize:14,color:TXT2,marginTop:8,fontFamily:FONT,fontStyle:"italic",letterSpacing:1}}>
            {L("依止传统智慧 · 明晰生命抉择","Traditional Wisdom Guidance for Life's Key Decisions")}
          </div>
        </div>

        {/* What is it */}
        <div style={{marginBottom:40}}>
          <h2 style={{fontSize:18,fontWeight:700,color:GDL,fontFamily:FONT,letterSpacing:1,marginBottom:14}}>
            {L("什么是缘起观察","What is Yuanqi Observation?")}
          </h2>
          <p style={{fontSize:15,lineHeight:1.9,color:TXT,fontFamily:FONT,margin:0}}>
            {L(
              "缘起观察是金刚乘传统中，依据传统智慧体系，为修行者在重要生命抉择时提供的参考指引。缘起，是佛法的核心洞见——一切现象皆因缘和合而生，并非孤立存在。通过观察当下时空的能量格局，我们可以更清晰地看见处境，从而做出更有智慧的抉择。",
              "Yuanqi Observation draws on traditional Vajrayana wisdom systems to offer reference guidance for practitioners facing important life decisions. Yuanqi — 'dependent origination' — is a core Buddhist insight: all phenomena arise through the interdependence of causes and conditions. By observing the energetic patterns of the present moment, we gain clarity about our situation and can make wiser choices."
            )}
          </p>
          <p style={{fontSize:15,lineHeight:1.9,color:TXT,fontFamily:FONT,marginTop:14}}>
            {L(
              "这不是命运判决，而是一面镜子。最终的抉择权始终在您手中，传统智慧只是帮助您看得更清晰。",
              "This is not a verdict on fate, but a mirror. The final decision always rests with you — traditional wisdom simply helps you see more clearly."
            )}
          </p>
        </div>

        {/* Four systems */}
        <div style={{marginBottom:44}}>
          <h2 style={{fontSize:18,fontWeight:700,color:GDL,fontFamily:FONT,letterSpacing:1,marginBottom:20}}>
            {L("四大传统体系","Four Traditional Systems")}
          </h2>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",gap:16}}>
            {SYSTEMS.map(s=>(
              <div key={s.zh} style={{
                background:"#fff",border:"1px solid rgba(212,175,55,0.18)",
                borderRadius:12,padding:"18px 16px",
              }}>
                <div style={{fontSize:22,marginBottom:8}}>{s.icon}</div>
                <div style={{fontSize:14,fontWeight:600,color:"#846B32",fontFamily:FONT,marginBottom:4}}>
                  {L(s.zh,s.en)}
                </div>
                <div style={{fontSize:11,color:TXT2,lineHeight:1.6,fontFamily:FONT}}>
                  {L(s.desc_zh,s.desc_en)}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Scenarios */}
        <div style={{marginBottom:44}}>
          <h2 style={{fontSize:18,fontWeight:700,color:GDL,fontFamily:FONT,letterSpacing:1,marginBottom:20}}>
            {L("适用场景","When to Seek Yuanqi Observation")}
          </h2>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:14}}>
            {SCENARIOS.map(s=>(
              <div key={s.zh} style={{
                background:"rgba(139,105,20,0.04)",border:"1px solid rgba(139,105,20,0.14)",
                borderRadius:10,padding:"14px 16px",
              }}>
                <div style={{fontSize:18,marginBottom:6}}>{s.icon}</div>
                <div style={{fontSize:13,fontWeight:600,color:"#846B32",fontFamily:FONT,marginBottom:4}}>
                  {L(s.zh,s.en)}
                </div>
                <div style={{fontSize:11,color:TXT2,lineHeight:1.6,fontFamily:FONT}}>
                  {L(s.desc_zh,s.desc_en)}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Notes */}
        <div style={{
          background:"rgba(139,105,20,0.05)",border:"1px solid rgba(139,105,20,0.18)",
          borderRadius:12,padding:"20px 24px",marginBottom:44,
        }}>
          <div style={{fontSize:13,fontWeight:700,color:GDL,fontFamily:FONT,marginBottom:10,letterSpacing:1}}>
            {L("注意事项","Important Notes")}
          </div>
          {[
            L("缘起观察是参考工具，非绝对预测，最终抉择权在您",
              "Yuanqi Observation is a reference tool, not a definitive prediction — you hold the final decision"),
            L("本服务不替代医疗、法律、财务等专业咨询",
              "This service does not replace medical, legal, or financial professional advice"),
            L("您的生辰信息及咨询内容严格保密，仅用于生成分析报告",
              "Your birth information and consultation content is kept strictly confidential"),
          ].map((note,i)=>(
            <div key={i} style={{display:"flex",gap:8,alignItems:"flex-start",marginBottom:8,
              fontSize:13,color:TXT,lineHeight:1.6,fontFamily:FONT}}>
              <span style={{color:GD,flexShrink:0,marginTop:2}}>·</span>
              <span>{note}</span>
            </div>
          ))}
        </div>

        {/* Access requirement */}
        <div style={{
          background:"#fff",border:"1.5px solid rgba(212,175,55,0.3)",
          borderRadius:12,padding:"24px 28px",textAlign:"center",
        }}>
          <div style={{fontSize:16,fontWeight:700,color:GD,fontFamily:FONT,marginBottom:12,letterSpacing:1}}>
            {L("申请缘起观察","Request Yuanqi Observation")}
          </div>
          <div style={{fontSize:13,color:TXT2,lineHeight:1.8,fontFamily:FONT,marginBottom:20}}>
            {L(
              "请联系社群管理团队，通过电子邮件或微信提交申请。我们将在3个工作日内回复。",
              "Please contact the community team via email or WeChat to submit your request. We will respond within 3 business days."
            )}
          </div>
          <div style={{display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap"}}>
            <a href="mailto:canada.btf@gmail.com" style={{
              padding:"10px 24px",borderRadius:24,
              background:`linear-gradient(135deg,${GD},${GDB})`,
              color:"#fff",textDecoration:"none",fontSize:13,
              fontFamily:FONT,letterSpacing:1,
            }}>
              📧 {L("发送邮件","Send Email")}
            </a>
            <button onClick={()=>navigate("/vajra")} style={{
              padding:"10px 24px",borderRadius:24,
              background:"transparent",border:`1.5px solid ${GD}`,
              color:GD,cursor:"pointer",fontSize:13,
              fontFamily:FONT,letterSpacing:1,
            }}>
              {L("返回社群首页","Back to Community")}
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}
